import http from '@/http'
const URL = '/admin/registration-controls'

export const list = async (params) => {
  const res = (await http.get(URL, { params: params }))
  return res
}

export const show = async (id) => {
  let one = null
  if (id) {
    one = (await http.get(URL + `/${id}`))
  }
  return one
}

export const save = (payload) => {
  if (payload.id) {
    return http.put(URL + `/${payload.id}`, payload)
  }
  return http.post(URL, payload)
}

export const remove = async (id) => http.delete(URL + `/${id}`)

// Groups
export const listGroups = (controlId, params) => {
  return http.get(URL + `/${controlId}/groups`, { params: params })
}

export const saveGroup = (controlId, payload) => {
  if (payload.id) {
    return http.put(URL + `/${controlId}/groups/${payload.id}`, payload)
  }
  return http.post(URL + `/${controlId}/groups`, payload)
}

export const removeGroup = async (controlId, id) => {
  return http.delete(URL + `/${controlId}/groups/${id}`)
}

export const importGroupsFile = (controlId, formData) => {
  return http.post(URL + `/${controlId}/groups/import-file`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  })
}

export const downloadGroupsTemplate = (controlId) => {
  return http.get(URL + `/${controlId}/groups/import-template`, { responseType: 'blob' })
}

// Items
export const listItems = (controlId, params) => {
  return http.get(URL + `/${controlId}/items`, { params: params })
}

export const showItem = (controlId, id) => {
  return http.get(URL + `/${controlId}/items/${id}`)
}

export const saveItem = (controlId, payload) => {
  if (payload.id) {
    return http.put(URL + `/${controlId}/items/${payload.id}`, payload)
  }
  return http.post(URL + `/${controlId}/items`, payload)
}

export const removeItem = async (controlId, id) => {
  return http.delete(URL + `/${controlId}/items/${id}`)
}

export const importItems = async (controlId, items) => {
  return http.post(URL + `/${controlId}/items/import`, { items })
}

export const importItemsFile = (controlId, formData) => {
  return http.post(URL + `/${controlId}/items/import-file`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  })
}

export const downloadImportTemplate = (controlId) => {
  return http.get(URL + `/${controlId}/items/import-template`, { responseType: 'blob' })
}

export const exportItems = (controlId, params) => {
  return http.get(URL + `/${controlId}/items/export`, { params: params, responseType: 'blob' })
}

export const bulkAssignItemsGroup = (controlId, payload) => {
  return http.post(URL + `/${controlId}/items/bulk-assign-group`, payload)
}

export const listForms = (params) => {
  return http.get('/admin/forms', { params })
}

export const listTags = (params) => {
  return http.get('/admin/tags', { params })
}

export default {
  list,
  show,
  save,
  remove,
  listGroups,
  saveGroup,
  removeGroup,
  importGroupsFile,
  downloadGroupsTemplate,
  listItems,
  showItem,
  saveItem,
  removeItem,
  importItems,
  importItemsFile,
  downloadImportTemplate,
  exportItems,
  bulkAssignItemsGroup,
  listForms,
  listTags
}
